import { render, staticRenderFns } from "./AssistantCatSelectionDialog.vue?vue&type=template&id=33aa49a0&scoped=true"
import script from "./AssistantCatSelectionDialog.vue?vue&type=script&lang=ts"
export * from "./AssistantCatSelectionDialog.vue?vue&type=script&lang=ts"
import style0 from "./AssistantCatSelectionDialog.vue?vue&type=style&index=0&id=33aa49a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa49a0",
  null
  
)

export default component.exports